import React from 'react';
import LoginComponent from '../components/LoginComponent';
import { fetchWithAuth } from '../utils/fetchWithAuth';

function LoginPage() {
  return (
    <div>
      <LoginComponent />
    </div>
  );
}

export default LoginPage;
